import React, { useEffect, useState } from "react";
import {
  Table,
  Badge,
  Dropdown,
  Button,
  Form,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { FaEye, FaPaypal } from "react-icons/fa";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import {
  AcceptRejectApi,
  changeStatusApi,
  deleteUserApi,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import Swal from "sweetalert2";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import { Loader } from "lucide-react";
import AddEdit from "./AddEdit";

const TableList = ({ userData, setUser, fetchedGetUsers, pageLoader, currentPage, rowsPerPage }) => {
  // ALL STATE
  const [loader, setLoader] = useState(false);
  const [acceptRejLoader, setAcceptRejLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [currentItems, setCurrentItems] = useState({});

  const handleShowModal = (item) => {
    setShow(!show);
    setCurrentItems(item);
  };

  return (
    <div className="card overflow-hidden all-tables">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile No</th>
                <th>Created At</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            {!pageLoader && userData?.length !== 0 && (
              <tbody>
                {userData &&
                  userData?.length > 0 &&
                  userData?.map((item, index) => {
                    return (
                      <tr>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          <strong className="text-black">{(currentPage - 1) * rowsPerPage + index + 1}</strong>
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {item?.firstName} {item.lastName}
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {item?.email}
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {item?.mobile}
                        </td>
                        <td
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          {formatDate(item?.createdAt)}
                        </td>

                        <td
                          className="text-center"
                          style={
                            item?.status == "rejected"
                              ? { backgroundColor: "#ffdfdf" }
                              : {}
                          }
                        >
                          <Link
                            to=""
                            className="text-black fs-5 px-1"
                            onClick={() => handleShowModal(item)}
                          >
                            <FaEye />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}

            {userData?.length < 0 && (
              <tbody>
                <tr className="text-center" colspan={7}>
                  <td colspan={7}>No Record Found</td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </div>

      {show && (
        <AddEdit
          show={show}
          onHide={handleShowModal}
          currentItems={currentItems}
          formatDate={formatDate}
        />
      )}
    </div>
  );
};

export default TableList;
